import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from '../../utils/convergence'
import { Grid, Text, DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { TermLink } from '../TermLink'

export const Terms: FunctionComponent = () => {
  const { t } = useTranslation()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const linkColor = isArcadeDesignLanguage ? 'Black' : 'Orca'

  return (
    <Grid>
      <Text color='Gray40' size='XXS' fontFace='CashSansMono'>
        <Trans
          i18nKey='verifyIdentity:licence:terms'
          components={{
            terms: <TermLink key='verify-identity-licence-terms' href={t('common:termsOfServiceUrl')} color={linkColor} fontFace='CashSansMono' />,
            privacy: <TermLink key='verify-identity-licence-privacy' href={t('common:privacyPolicyUrl')} color={linkColor} fontFace='CashSansMono' />,
          }}
        />
      </Text>
    </Grid>
  )
}
